import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { BedroomService } from 'src/app/api/hospitality/bedroom.service';
import { RoomtypeService } from 'src/app/api/hospitality/roomtype.service';
import { ToolsService } from 'src/app/utils/tools.service';
import SwalAlert from 'src/app/utils/swalalert';
declare var $: any;

@Component({
  selector: 'app-bedroom-form',
  templateUrl: './bedroom-form.component.html',
  styleUrls: ['./bedroom-form.component.css']
})
export class BedroomFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  // variables
  roomtypes: any = [];
  variations_selecteds: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private roomtypeService: RoomtypeService,
    private bedroomService: BedroomService,
    public toolsService: ToolsService,
    private route: ActivatedRoute,
    private alert: SwalAlert,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      code_number: ['', [Validators.required, Validators.minLength(2)]],
      roomtype_id: [null, [Validators.required]],
      description: [null],
      floor: [null],
      observations: [null],
      is_variation_roomtype: [false]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.route);
    this.getRoomTypes();
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.bedroomService.get(this.checkId).subscribe({
      next: (data: any) => {
        let item_ = data.data;
        this.item.patchValue({
          code_number: item_.code_number,
          roomtype_id: item_.roomtype_id,
          description: item_.description,
          floor: item_.floor ? Number(item_.floor) : null,
          observations: item_.observations,
          is_variation_roomtype: item_.is_variation_roomtype
        });

        setTimeout(() => {
          if (item_.is_variation_roomtype) {
            for (let i in item_.bedroom_variations) {
              let room = this.toolsService.searchObjById(
                item_.bedroom_variations[i].roomtype.id,
                this.roomtypes
              );
              $(
                '#bedroom_available' + item_.bedroom_variations[i].roomtype.id
              ).prop('checked', true);
              this.variations_selecteds.push(room);
            }
          }
        }, 150);
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  getRoomTypes() {
    this.roomtypeService.all().subscribe({
      next: (data: any) => {
        this.roomtypes = data.results;
      }
    });
  }

  changeIsVariation() {
    if (this.item.value.roomtype_id != null) {
      if (this.item.value.is_variation_roomtype) {
        (<any>$('#roomTypeSelected')).attr('disabled', true);
      } else {
        (<any>$('#roomTypeSelected')).attr('disabled', false);
        this.variations_selecteds = [];
      }
    } else {
      this.alertifyMsg.warning('Debe seleccionar el tipo de habitación');
      this.item.patchValue({
        is_variation_roomtype: false
      });
      setTimeout(() => {
        $('#is_variation_roomtype').prop('checked', false);
      }, 50);
    }
  }

  selectedVariations(item_: any) {
    let validate_ = this.toolsService.notExistObjInArr(
      item_,
      this.variations_selecteds
    );
    if (validate_) {
      this.variations_selecteds.push(item_);
    } else {
      let index = this.variations_selecteds.indexOf(item_);
      this.variations_selecteds.splice(index, 1);
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      let data: any = {};
      data.item = this.item.value;
      data.variations_selecteds = this.variations_selecteds;

      if (this.isEdit) {
        this.bedroomService.update(this.checkId, data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.bedroomService.save(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  validate() {
    if (this.item.value.is_variation_roomtype) {
      if (this.variations_selecteds.length == 0) {
        let options = {
          title: 'Advertencia !',
          message: 'Debe seleccionar al menos una variación de tipo de habitación'
        };
        this.alert.warning(options);
        return false;
      }
    }

    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/hoteleria/habitaciones/lista'
    ]);
  }
}
